import React from "react";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";

const SupplierSearchBar = ({ query, onChange, onClear }) => (
    <TextField
        label="Suchen"
        value={query}
        onChange={(event) => onChange(event.target.value)}
        fullWidth
        InputProps={{
            startAdornment: (
                <InputAdornment position="start">
                    <SearchRoundedIcon />
                </InputAdornment>
            ),
            endAdornment: query ? (
                <InputAdornment position="end">
                    <IconButton size="small" onClick={onClear}>
                        <CloseRoundedIcon />
                    </IconButton>
                </InputAdornment>
            ) : null,
        }}
    />
);

export default SupplierSearchBar;
